"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _uuid = _interopRequireDefault(require("uuid"));

var _constants = require("../constants");

var MembersUtil = {};
/**
 * @param {Object} invitee with emailAddress, email or phoneNumber
 * @param {String} locusUrl
 * @param {Boolean} alertIfActive
 * @returns {Object} the format object
 */

MembersUtil.generateAddMemberOptions = function (invitee, locusUrl, alertIfActive) {
  return {
    invitee: invitee,
    locusUrl: locusUrl,
    alertIfActive: alertIfActive
  };
};
/**
 * @param {Array} memberIds
 * @param {String} locusUrl
 * @returns {Object} the format object
 */


MembersUtil.generateAdmitMemberOptions = function (memberIds, locusUrl) {
  return {
    locusUrl: locusUrl,
    memberIds: memberIds
  };
};
/**
 * @param {Object} options with {invitee: {emailAddress, email, phoneNumber}, alertIfActive}
 * @returns {Object} with {invitees: [{address}], alertIfActive}
 */


MembersUtil.getAddMemberBody = function (options) {
  return {
    invitees: [{
      address: options.invitee.emailAddress || options.invitee.email || options.invitee.phoneNumber
    }],
    alertIfActive: options.alertIfActive
  };
};
/**
 * @param {Object} options with {memberIds}
 * @returns {Object} admit with {memberIds}
 */


MembersUtil.getAdmitMemberRequestBody = function (options) {
  return {
    admit: {
      participantIds: options.memberIds
    }
  };
};
/**
 * @param {Object} format with {memberIds, locusUrl}
 * @returns {Object} the request parameters (method, uri, body) needed to make a admitMember request
 */


MembersUtil.getAdmitMemberRequestParams = function (format) {
  var body = MembersUtil.getAdmitMemberRequestBody(format);
  var uri = "".concat(format.locusUrl, "/").concat(_constants.CONTROLS);
  return {
    method: _constants.HTTP_VERBS.PUT,
    uri: uri,
    body: body
  };
};
/**
 * @param {Object} format with {invitee {emailAddress, email, phoneNumber}, locusUrl, alertIfActive}
 * @returns {Object} the request parameters (method, uri, body) needed to make a addMember request
 */


MembersUtil.getAddMemberRequestParams = function (format) {
  var body = MembersUtil.getAddMemberBody(format);
  var requestParams = {
    method: _constants.HTTP_VERBS.PUT,
    uri: format.locusUrl,
    body: body
  };
  return requestParams;
};

MembersUtil.isInvalidInvitee = function (invitee) {
  if (!(invitee && (invitee.email || invitee.emailAddress || invitee.phoneNumber))) {
    return true;
  }

  if (invitee.phoneNumber) {
    return !_constants.DIALER_REGEX.E164_FORMAT.test(invitee.phoneNumber);
  }

  return !_constants.VALID_EMAIL_ADDRESS.test(invitee.email || invitee.emailAddress);
};

MembersUtil.getRemoveMemberRequestParams = function (options) {
  var body = {
    reason: options.reason
  };
  var uri = "".concat(options.locusUrl, "/").concat(_constants.PARTICIPANT, "/").concat(options.memberId, "/").concat(_constants.LEAVE);
  return {
    method: _constants.HTTP_VERBS.PUT,
    uri: uri,
    body: body
  };
};

MembersUtil.generateTransferHostMemberOptions = function (transfer, moderator, locusUrl) {
  return {
    moderator: moderator,
    locusUrl: locusUrl,
    memberId: transfer
  };
};

MembersUtil.generateRemoveMemberOptions = function (removal, locusUrl) {
  return {
    reason: _constants._FORCED_,
    memberId: removal,
    locusUrl: locusUrl
  };
};

MembersUtil.generateMuteMemberOptions = function (mute, status, locusUrl) {
  return {
    memberId: mute,
    muted: status,
    locusUrl: locusUrl
  };
};

MembersUtil.getMuteMemberRequestParams = function (options) {
  var body = {
    audio: {
      muted: options.muted
    }
  };
  var uri = "".concat(options.locusUrl, "/").concat(_constants.PARTICIPANT, "/").concat(options.memberId, "/").concat(_constants.CONTROLS);
  return {
    method: _constants.HTTP_VERBS.PATCH,
    uri: uri,
    body: body
  };
};

MembersUtil.getTransferHostToMemberRequestParams = function (options) {
  var body = {
    role: {
      moderator: options.moderator
    }
  };
  var uri = "".concat(options.locusUrl, "/").concat(_constants.PARTICIPANT, "/").concat(options.memberId, "/").concat(_constants.CONTROLS);
  return {
    method: _constants.HTTP_VERBS.PATCH,
    uri: uri,
    body: body
  };
};

MembersUtil.genderateSendDTMFOptions = function (url, tones, memberId, locusUrl) {
  return {
    url: url,
    tones: tones,
    memberId: memberId,
    locusUrl: locusUrl
  };
};

MembersUtil.generateSendDTMFRequestParams = function (_ref) {
  var url = _ref.url,
      tones = _ref.tones,
      memberId = _ref.memberId,
      locusUrl = _ref.locusUrl;
  var body = {
    device: {
      url: url
    },
    memberId: memberId,
    dtmf: {
      correlationId: _uuid.default.v4(),
      tones: tones,
      direction: 'transmit'
    }
  };
  var uri = "".concat(locusUrl, "/").concat(_constants.PARTICIPANT, "/").concat(memberId, "/").concat(_constants.SEND_DTMF_ENDPOINT);
  return {
    method: _constants.HTTP_VERBS.POST,
    uri: uri,
    body: body
  };
};

MembersUtil.cancelPhoneInviteOptions = function (invitee, locusUrl) {
  return {
    invitee: invitee,
    locusUrl: locusUrl
  };
};

MembersUtil.generateCancelInviteRequestParams = function (options) {
  var body = {
    actionType: _constants._REMOVE_,
    invitees: [{
      address: options.invitee.phoneNumber
    }]
  };
  var requestParams = {
    method: _constants.HTTP_VERBS.PUT,
    uri: options.locusUrl,
    body: body
  };
  return requestParams;
};

var _default = MembersUtil;
exports.default = _default;
//# sourceMappingURL=util.js.map
